import React from 'react'
import { ClientDiscountActions } from '../ClientDiscountActions'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import PictureAsPdfOutlined from '@material-ui/icons/PictureAsPdfOutlined'
import * as css from './OrderManagementActions.css'

interface IOrderManagementActionsProps {
  orderNumber: string
  onDelete: (e: any) => void
  onExportToPDF: (e: any) => void
  disabledDelete: boolean
  disablePDFExport: boolean
  isPDFExportInProcess: boolean
}

export const OrderManagementActions: React.FunctionComponent<
  IOrderManagementActionsProps
> = ({
  orderNumber,
  onDelete,
  onExportToPDF,
  disabledDelete,
  disablePDFExport,
  isPDFExportInProcess
}) => {
  return (
    <div className={css.orderActions}>
      <ClientDiscountActions
        onDelete={onDelete}
        disabled={disabledDelete || false}
        dontFreezeActionOnClick
      />
      {orderNumber &&
        (isPDFExportInProcess ? (
          <CircularProgress classes={{ root: css.circularProgress }} size={15} />
        ) : (
          <IconButton
            disabled={disablePDFExport}
            classes={{
              root: disablePDFExport ? css.disabled : ''
            }}
            onClick={onExportToPDF}
          >
            <PictureAsPdfOutlined />
          </IconButton>
        ))}
    </div>
  )
}
